module.exports = __webpack_public_path__ + "static/logo-7f8e6fcb69f24ecec0f2cfc33afe6377.png";